import { useEffect, useMemo, useState } from "react";
import axios from "api/axios";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PageShell, { SectionCard } from "components/patch/PageShell";
import SimpleTable from "components/patch/SimpleTable";

export default function RecurringAllowances() {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({ pf_no: "", allowance_code: "" });
  const [form, setForm] = useState({
    pf_no: "",
    allowance_code: "",
    allowance_name: "",
    amount: "",
    effective_from: "",
    effective_to: "",
  });
  const [uploadFile, setUploadFile] = useState(null);

  const load = async () => {
    const res = await axios.get("/pay-items/allowances", { params: { ...filters, per_page: 200 } });
    setRows(res.data?.data?.data || res.data?.data || []);
  };
  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    await axios.post("/pay-items/allowances", {
      ...form,
      amount: Number(form.amount || 0),
      is_taxable: true,
      is_proratable: true,
      is_active: true,
    });
    setForm({
      pf_no: "",
      allowance_code: "",
      allowance_name: "",
      amount: "",
      effective_from: "",
      effective_to: "",
    });
    await load();
  };

  const upload = async () => {
    if (!uploadFile) return;
    const fd = new FormData();
    fd.append("file", uploadFile);
    await axios.post("/pay-items/allowances/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    setUploadFile(null);
    await load();
  };

  return (
    <PageShell
      title="Recurring Allowances"
      subtitle="Manual entry plus bulk upload for regular monthly allowances."
    >
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <SectionCard title="Create Allowance">
            <MDBox display="flex" flexDirection="column" gap={2}>
              <MDInput
                label="PF No"
                value={form.pf_no}
                onChange={(e) => setForm({ ...form, pf_no: e.target.value })}
              />
              <MDInput
                label="Allowance Code"
                value={form.allowance_code}
                onChange={(e) => setForm({ ...form, allowance_code: e.target.value })}
              />
              <MDInput
                label="Allowance Name"
                value={form.allowance_name}
                onChange={(e) => setForm({ ...form, allowance_name: e.target.value })}
              />
              <MDInput
                type="number"
                label="Amount"
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })}
              />
              <MDInput
                type="date"
                InputLabelProps={{ shrink: true }}
                label="Effective From"
                value={form.effective_from}
                onChange={(e) => setForm({ ...form, effective_from: e.target.value })}
              />
              <MDInput
                type="date"
                InputLabelProps={{ shrink: true }}
                label="Effective To"
                value={form.effective_to}
                onChange={(e) => setForm({ ...form, effective_to: e.target.value })}
              />
              <MDButton variant="gradient" color="success" onClick={create}>
                Save
              </MDButton>
            </MDBox>
          </SectionCard>
        </Grid>
        <Grid item xs={12} lg={8}>
          <SectionCard title="Bulk Upload & Register">
            <MDBox display="flex" gap={1} flexWrap="wrap" mb={2}>
              <MDButton
                variant="outlined"
                color="info"
                component="a"
                href={`${
                  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api"
                }/templates/recurring-allowances`}
                target="_blank"
                rel="noreferrer"
              >
                Sample Template
              </MDButton>
              <MDButton variant="outlined" component="label">
                Select Upload
                <input
                  hidden
                  type="file"
                  onChange={(e) => setUploadFile(e.target.files?.[0] || null)}
                />
              </MDButton>
              <MDButton variant="gradient" color="info" onClick={upload} disabled={!uploadFile}>
                Upload
              </MDButton>
            </MDBox>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} md={6}>
                <MDInput
                  label="Filter PF No"
                  value={filters.pf_no}
                  onChange={(e) => setFilters({ ...filters, pf_no: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <MDInput
                  label="Filter Code"
                  value={filters.allowance_code}
                  onChange={(e) => setFilters({ ...filters, allowance_code: e.target.value })}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <MDButton variant="gradient" color="dark" onClick={load}>
                  Load
                </MDButton>
              </Grid>
            </Grid>
            <SimpleTable
              columns={[
                { key: "pf_no", label: "PF No" },
                { key: "allowance_code", label: "Code" },
                { key: "allowance_name", label: "Name" },
                { key: "amount", label: "Amount" },
                { key: "effective_from", label: "From" },
                { key: "effective_to", label: "To" },
              ]}
              rows={rows}
            />
          </SectionCard>
        </Grid>
      </Grid>
    </PageShell>
  );
}
